import { render, staticRenderFns } from "./AddPrimary.vue?vue&type=template&id=18f6259a&"
import script from "./AddPrimary.vue?vue&type=script&lang=js&"
export * from "./AddPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports